import { render } from "./GroupStoresTab.vue?vue&type=template&id=5cd3a6b8&scoped=true"
import script from "./GroupStoresTab.vue?vue&type=script&lang=js"
export * from "./GroupStoresTab.vue?vue&type=script&lang=js"

import "./GroupStoresTab.vue?vue&type=style&index=0&id=5cd3a6b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cd3a6b8"]])

export default __exports__